<template>
  <div>
    <shop-header :store-id="storeid" />
    <div class="container main-container">
      <div class="row">
        <div class="col-xl-12">
          <div class="bg-white py-4">
            <div class="p-4 d-flex justify-content-center">
              <div class="w-85">
                <h2>Thank you</h2>
                <p>{{ message }}</p>
                <br />
                <button
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="continueOrder"
                >
                  {{ $t("message.continueOrdering") }}
                </button>
                <button
                  v-show="
                    !isGift() && !user && viewConfig.LogIn && this.isBranded()
                  "
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="GoRegister"
                >
                  {{ $t("message.becomeMember") }}
                </button>
                <poweredby />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <shopfooter />
  </div>
</template>
<script>
import ShopHeader from "./../partials/shopheader";
import shopfooter from "./../../shared/shopfooter";
import { mapMutations, mapGetters } from "vuex";
import poweredby from "../../shared/poweredby";
export default {
  components: {
    ShopHeader,
    shopfooter,
    poweredby,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["viewConfig", "user"]),
    message() {
      if (this.isGift()) return this.getThankYouMessage();
      else
        return "A request has been sent. Please check your email to see the status of your order.";
    },
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...mapGetters(["getThankYouMessage", "isGift"]),
    ...mapMutations(["setStoreLoaded"]),
    continueOrder() {
      if (this.isGift())
        this.$router.push({
          name: "giftstorev2",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      else
        this.$router.push({
          name: "store",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
    },
    GoRegister() {
      this.$router.push("/Register");
    },
  },
};
</script>
